export default function formatPrice(num: number | string | undefined | null, round?: boolean) {
  let numericNum = Number(num);
  let _round = round;

  if (_round) {
    numericNum = Math.round(numericNum);
  }

  if (Number.isNaN(numericNum)) {
    return undefined;
  }

  if (numericNum === Math.round(numericNum)) {
    _round = true;
  }

  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: _round ? 0 : undefined }).format(numericNum);
}
